var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6 0.117188C10.208 0.117188 8.872 0.823455 8 1.93953C7.128 0.823455 5.792 0.117188 4.4 0.117188C1.936 0.117188 0 2.22727 0 4.91283C0 8.20874 2.72 10.8943 6.84 14.975L8 16.1172L9.16 14.9662C13.28 10.8943 16 8.20874 16 4.91283C16 2.22727 14.064 0.117188 11.6 0.117188ZM8.08 13.6758L8 13.763L7.92 13.6758C4.112 9.91773 1.6 7.43272 1.6 4.91283C1.6 3.16896 2.8 1.86106 4.4 1.86106C5.632 1.86106 6.832 2.72427 7.256 3.91882H8.752C9.168 2.72427 10.368 1.86106 11.6 1.86106C13.2 1.86106 14.4 3.16896 14.4 4.91283C14.4 7.43272 11.888 9.91773 8.08 13.6758Z",
    fill: "#004494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHeart);
export default __webpack_public_path__ + "static/media/empty_heart.521a0dbec70b890235fae8c06adfa1ef.svg";
export { ForwardRef as ReactComponent };